module.exports = __webpack_public_path__ + "files/0432bdb18eb790ad98ca15758e511efa.png";